import PropTypes from "prop-types";

import { AREA_TYPES } from "../../../constants/geographyConstants";
import InputRadioGroup from "../../../ui/InputRadioGroup";
import AadtInputGroup from "./AadtInputGroup";
import { Typography } from "@mui/material";
import D4DiagramDialog from "../../../ui/D4DiagramDialog";
import { ORIENTATIONS } from "../../../constants/intxConstants";
import { INTERSECTION_NUMBERS } from "../../../constants/storageConstants";
import ObservedCrashesFields from "./ObservedCrashesFields";

export default function InterchangeGlobalSafetyDataFields({
  defaultValues,
  errors,
  formData,
  hasCurrentIntersection,
  EWFacilityName,
  NSFacilityName,
  orientation,
  register,
}) {
  return (
    <>
      <InputRadioGroup
        buttonDirection="row"
        title="Area Type"
        name="areaType"
        defaultValue={defaultValues.areaType ?? AREA_TYPES.URBAN}
        options={[
          { value: AREA_TYPES.URBAN, label: "Urban" },
          { value: AREA_TYPES.RURAL, label: "Rural" },
        ]}
        register={register}
      />
      {Object.values(INTERSECTION_NUMBERS).map((intersectionKey, index) => (
        <div key={intersectionKey} style={{ marginBottom: "80px" }}>
          <Typography sx={{ marginTop: "40px" }} variant="h6">
            Intersection {index + 1}{" "}
            <D4DiagramDialog
              orientation={orientation}
              EWFacilityName={EWFacilityName}
              NSFacilityName={NSFacilityName}
            />
          </Typography>
          <AadtInputGroup
            defaultValues={defaultValues}
            errors={errors}
            formData={formData}
            groups={[
              {
                id: `${intersectionKey}.insideCrossroadLeg`,
                label: "Inside Crossroad Leg",
              },
              {
                id: `${intersectionKey}.outsideCrossroadLeg`,
                label: "Outside Crossroad Leg",
              },
            ]}
            register={register}
          />
          <AadtInputGroup
            defaultValues={defaultValues}
            errors={errors}
            formData={formData}
            groups={[
              {
                id: `${intersectionKey}.exitRamp`,
                label: "Exit Ramp",
              },
              {
                id: `${intersectionKey}.entranceRamp`,
                label: "Entrance Ramp",
              },
            ]}
            register={register}
          />
          {hasCurrentIntersection && (
            <ObservedCrashesFields
              defaultValues={defaultValues}
              errors={errors}
              formData={formData}
              intersectionKey={intersectionKey}
              register={register}
            />
          )}
        </div>
      ))}
    </>
  );
}

InterchangeGlobalSafetyDataFields.propTypes = {
  defaultValues: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  EWFacilityName: PropTypes.string,
  formData: PropTypes.object.isRequired,
  hasCurrentIntersection: PropTypes.bool.isRequired,
  NSFacilityName: PropTypes.string,
  orientation: PropTypes.oneOf(Object.values(ORIENTATIONS)).isRequired,
  register: PropTypes.func.isRequired,
};
